import N8nCanvasThinkingPill from './CanvasThinkingPill.vue';

export default N8nCanvasThinkingPill;
